import { useEffect } from 'react'
import { Route, Routes, useNavigate } from 'react-router-dom'
import AppLayout from './components/AppLayout'
import ControlsPage from './pages/ControlsPage'
import DocumentsPage from './pages/DocumentsPage'
import ForgotPasswordPage from './pages/ForgotPasswordPage'
import LoginPage from './pages/LoginPage'
import LogoutPage from './pages/LogoutPage'
import NotificationsPage from './pages/NotificationsPage'
import ResetPasswordPage from './pages/ResetPasswordPage'
import UsersPage from './pages/UsersPage'

function Dummy({ message }: { message?: string }) {
  return (
    <div>
      <h1 className='text-3xl font-bold underline'>{message ?? 'Hello world from Frontend!'}</h1>
      <p>This is just a dummy page though.</p>
    </div>
  )
}
const Redirector = ({ message }: { message?: string }) => {
  const navigate = useNavigate()
  useEffect(() => {
    navigate('/controls')
  })
  return <Dummy message={message ?? `You look lost. Let's get you somewhere`} />
}

const AppPages = () => (
  <Routes>
    <Route path='auth'>
      <Route path='login' Component={LoginPage} />
      <Route path='logout' Component={LogoutPage} />
      <Route path='forgot-password' Component={ForgotPasswordPage} />
      <Route path='reset-password' Component={ResetPasswordPage} />
    </Route>
    <Route path='' Component={AppLayout}>
      <Route path='controls' Component={ControlsPage} />
      <Route path='documents' Component={DocumentsPage} />
      <Route path='notifications' Component={NotificationsPage} />
      <Route path='users' Component={UsersPage} />
      <Route path='*' Component={Redirector} />
    </Route>
  </Routes>
)

export default AppPages
